module.exports = __webpack_public_path__ + "static/media/thum2.e2cb012d.jpg";